enum topMenuTestIds {
	SiteToolsDropdown = 'site-tools-drop-down',
	topMenuContainer = 'adviser-top-menu',
	topMenuLinks = 'adviser-topMenu-links',
	userSiteToolsLink = 'user-site-tools-menu-link',
	topMenuSearchModal = 'top-menu-search-modal',
	topMenuSearchModalContainer = 'top-menu-search-modal-container',
	topMenuSearchButton = 'search-component-button',
	topMenuSearchModalInput = 'search-modal-input',
	topMenuSearch = 'top-menu-search',
}

export default topMenuTestIds;
